"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_desktop__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "81f373f9-f0d6-4ad7-825e-95d80ca156bb",
    x1: 46,
    y1: 30,
    x2: 146,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "52ca0533-d0e7-46f8-acc3-990a8ddc4b78",
    x1: 61.88,
    y1: 86.12,
    x2: 151.88,
    y2: 176.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "013f90be-9b96-46c0-bae6-81b0b06d73dd",
    "data-name": "Desktop_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,120V44.06A4.08,4.08,0,0,1,32.06,40H159.94A4.08,4.08,0,0,1,164,44.06V120Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 152 28 120 164 120 176 152 16 152",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 152 28 120 164 120 176 152 16 152",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 42,
    width: 132,
    height: 76,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 44,
    width: 128,
    height: 72,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 44,
    width: 128,
    height: 72,
    opacity: 0.5,
    fill: "url(#81f373f9-f0d6-4ad7-825e-95d80ca156bb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,152H176a0,0,0,0,1,0,0v4a4,4,0,0,1-4,4H20a4,4,0,0,1-4-4v-4A0,0,0,0,1,16,152Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,158H20a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172a4,4,0,0,0,4-4v-2A4,4,0,0,1,172,158Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61 152 28 120 163.5 120 176 152 61 152",
    opacity: 0.2,
    fill: "url(#52ca0533-d0e7-46f8-acc3-990a8ddc4b78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 138,
    width: 47.91,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "desktop-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "48a46d95-a90b-4a09-9d8f-ffc8b4b131ef",
    "data-name": "Desktop_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "b94d72bb-2646-4649-83de-57a2c04a589b",
    "data-name": "Desktop_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#013f90be-9b96-46c0-bae6-81b0b06d73dd"
  })));
}

var _default = ic_desktop__dark;
exports.default = _default;